import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { BooleanInput } from '@angular/cdk/coercion';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { User } from 'app/core/user/user.model';
import { UserService } from 'app/core/user/user.service';
import { MatDialog } from '@angular/material/dialog';
import { ChangePasswordComponent } from 'app/modules/auth/change-password/change-password.component';

import { UserService as UserService2 } from 'app/core/auth/tmp/user2.service';

@Component({
    selector       : 'user-menu',
    templateUrl    : './user-menu.component.html',
    encapsulation  : ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs       : 'userMenu'
})
export class UserMenuComponent implements OnInit, OnDestroy
{
    static ngAcceptInputType_showAvatar: BooleanInput;


    @Input() showAvatar: boolean = true;
    user: User;

    urlAvatar = '/assets/images/avatars/profile.png';

    private _unsubscribeAll: Subject<any> = new Subject<any>();

    /**
     * Constructor
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _router: Router,
        private _userService: UserService,
        private _matDialog: MatDialog,
        private _userService2: UserService2
    )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        // Subscribe to user changes
        this._userService.user$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((user: User) => {
                this.user = user;

                if ( user.avatarId ) {
                    this.urlAvatar = `/api/file/download/${ user.avatarId }`
                }
                // Mark for check
                this._changeDetectorRef.markForCheck();
            });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------


    perfil(): void {
        this._router.navigate(['/acount', 'settings']);
    }

    /**
     * Sign out
     */
    signOut(): void
    {
        this._userService2.clearUser();
        this._router.navigate(['/sign-out']);
    }


    changePasswordDialog(): void {

        const dialogRef = this._matDialog.open(
            ChangePasswordComponent,
            {
                width: '350px',
                disableClose: true,
                autoFocus: true
            }
        );


        dialogRef.afterClosed()
        .subscribe( ( result ) => {
        });

    }
}
